export default "__VITE_ASSET__gLv8MQ6M__"